/**
 * @generated SignedSource<<4b992f02f654eeabf19eead867ed8a81>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CurrencyType = "CAD" | "EUR" | "USD" | "%future added value";
export type DataGranularity = "MONTHLY" | "WEEKLY" | "%future added value";
export type FbAccessTokenType = "LP" | "%future added value";
export type CreateBrandRequest = {
  accountId: string;
  currencyType?: CurrencyType | null;
  dataGranularity?: DataGranularity | null;
  fbAccessTokenType?: FbAccessTokenType | null;
  featureFlagIds?: ReadonlyArray<string> | null;
  insightsThreshold?: number | null;
  metaAdAccountExternalId: string;
  minAdSpend?: number | null;
  name: string;
};
export type BrandFormCreateMutation$variables = {
  input: CreateBrandRequest;
};
export type BrandFormCreateMutation$data = {
  readonly createBrand: {
    readonly id: string;
  };
};
export type BrandFormCreateMutation = {
  response: BrandFormCreateMutation$data;
  variables: BrandFormCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AdminBrand",
    "kind": "LinkedField",
    "name": "createBrand",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BrandFormCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BrandFormCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1f544b285f1b9fc7df7edb7741505898",
    "id": null,
    "metadata": {},
    "name": "BrandFormCreateMutation",
    "operationKind": "mutation",
    "text": "mutation BrandFormCreateMutation(\n  $input: CreateBrandRequest!\n) {\n  createBrand(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "5f7eaabd4337f0a26dfb6bb4864150f2";

export default node;
